<template>
<div class="chapter">
<div class="inner_page">
<div class="titlepage">
<h1 class="title1">SPELLS<br/><span class="bi">And How They Work</span><br/><br/></h1>
<h1 class="title3">Janet and Stewart Farrar<br/><br/></h1>
<p class="center"><strong>With line illustrations by Stewart Farrar</strong><br/><br/><br/><br/><br/><br/></p>
<p class="center"><img alt="" src="OEBPS/images/logo.jpg"/></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// tp.vue?5b97f891